module.exports = __webpack_public_path__ + "static/d8602bd0.tip.png";